import BaseModelAPI from '../BaseModelAPI';

export default class PrinterInformation extends BaseModelAPI {
	static entity = 'printerinformation';
	static entityName = 'printerinformation';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.name = '';
			this.printerIpAddress = '';
			this.printerPort = '';
			this.isMobilePrinter = false;
			this.isDisabled = false;
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}